const rand = (a, b) => a + Math.random() * (b - a);

function items(n, y0, y1, s0, s1) {
  return Array.from({ length: n }, (_, i) => ({ x: Math.random(), y: rand(y0, y1), s: rand(s0, s1), kind: i % 5 === 0 ? "lotus" : i % 7 === 0 ? "lily" : "pad", ph: rand(0, 6), bob: 0, dx: 0 }));
}

function pad(g, x, y, r) {
  g.beginPath();
  g.moveTo(x, y);
  g.ellipse(x, y, r, r * 0.34, 0, 0.35, Math.PI * 2 - 0.35);
  g.closePath();
  g.fill();
}
function lotus(g, x, y, r, white) {
  for (let i = -3; i <= 3; i++) {
    const a = (i / 3) * 1.05;
    g.save();
    g.translate(x, y);
    g.rotate(a);
    const gr = g.createLinearGradient(0, 0, 0, -r);
    gr.addColorStop(0, white ? "#E8DCE6" : "#D2709A");
    gr.addColorStop(1, white ? "#FFFFFF" : "#FBE0EC");
    g.fillStyle = gr;
    g.beginPath();
    g.moveTo(0, 0);
    g.quadraticCurveTo(r * 0.38, -r * 0.55, 0, -r * (1 - Math.abs(i) * 0.08));
    g.quadraticCurveTo(-r * 0.38, -r * 0.55, 0, 0);
    g.fill();
    g.restore();
  }
}
function lily(g, x, y, r) {
  g.fillStyle = "#FBF6EA";
  for (let i = 0; i < 10; i++) {
    g.beginPath();
    g.ellipse(x + Math.cos((i / 10) * Math.PI * 2) * r * 0.5, y + Math.sin((i / 10) * Math.PI * 2) * r * 0.17, r * 0.5, r * 0.1, (i / 10) * Math.PI * 2 * 0.33, 0, Math.PI * 2);
    g.fill();
  }
  g.fillStyle = "#F2C94C";
  g.fillRect(x - r * 0.08, y - r * 0.05, r * 0.16, r * 0.1);
}

export function createPond2D(canvas, painting) {
  const g = canvas.getContext("2d");
  const pal = painting.palette || [];
  const layers = [items(26, 0.47, 0.6, 10, 20), items(20, 0.56, 0.8, 22, 40), items(12, 0.74, 1.04, 48, 80)];
  const rings = [];
  const st = { stage: "pond", calm: 0, px: 0, t0: performance.now(), ripples: 0 };
  let W = 0, H = 0, raf, last = performance.now();
  const size = () => {
    const dpr = Math.min(1.5, window.devicePixelRatio || 1);
    W = canvas.clientWidth;
    H = canvas.clientHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  size();
  window.addEventListener("resize", size);
  const frame = (now) => {
    const t = (now - st.t0) / 1000;
    const dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    st.calm += ((st.stage === "pond" ? 0 : 1) - st.calm) * (1 - Math.exp(-dt * 1.2));
    const still = 1 - st.calm;
    const hz = H * 0.44;
    let gr = g.createLinearGradient(0, 0, 0, hz);
    gr.addColorStop(0, "#D8D0E2");
    gr.addColorStop(1, "#F2DCCF");
    g.fillStyle = gr;
    g.fillRect(0, 0, W, hz);
    g.fillStyle = pal[0] || "#424756";
    g.beginPath();
    g.moveTo(0, hz);
    for (let x = -10, i = 0; x <= W + 20; x += 9, i++) g.lineTo(x + st.px * 20, hz - 30 - (i % 2 ? 0 : 50 + ((i * 37) % 60) + Math.sin(i * 0.7) * 18));
    g.lineTo(W, hz);
    g.fill();
    gr = g.createLinearGradient(0, hz, 0, H);
    gr.addColorStop(0, "#9AA2B4");
    gr.addColorStop(0.25, pal[1] || "#4f4b59");
    gr.addColorStop(1, pal[0] || "#2f3445");
    g.fillStyle = gr;
    g.fillRect(0, hz, W, H - hz);
    g.strokeStyle = "rgba(255,246,232,0.5)";
    g.lineWidth = 1.2;
    for (let i = 0; i < 26; i++) {
      const y = hz + ((i * 37) % (H - hz));
      const x = ((i * 131 + t * 18 * still) % (W + 80)) - 40;
      g.globalAlpha = (0.3 + 0.3 * Math.sin(t * 2 + i)) * (0.4 + 0.6 * still);
      g.beginPath();
      g.moveTo(x, y);
      g.lineTo(x + 18 + (i % 4) * 8, y);
      g.stroke();
    }
    g.globalAlpha = 1;
    for (let r = rings.length - 1; r >= 0; r--) {
      const q = rings[r];
      const age = (now - q.t0) / 1000;
      if (age > 5) {
        rings.splice(r, 1);
        continue;
      }
      for (let k = 0; k < 3; k++) {
        const rad = (age * 90 - k * 18) * q.k;
        if (rad <= 0) continue;
        g.strokeStyle = `rgba(255,255,255,${Math.max(0, 0.55 - age * 0.11) * still})`;
        g.lineWidth = 1.5;
        g.beginPath();
        g.ellipse(q.x, q.y, rad, rad * 0.32, 0, 0, Math.PI * 2);
        g.stroke();
      }
    }
    layers.forEach((L, li) => {
      const par = (li + 1) * 10;
      L.forEach((it) => {
        it.bob *= Math.exp(-dt);
        const x = it.x * (W + 120) - 60 + st.px * par + Math.sin(t * 0.3 + it.ph) * 6 * still + it.dx;
        const y = H * it.y + (Math.sin(t * 1.2 + it.ph) * 1.5 + Math.sin(t * 6 + it.ph) * 6 * it.bob) * still;
        g.fillStyle = li === 2 ? "#3F5E45" : li === 1 ? "#4C6A4C" : "#5D7458";
        pad(g, x, y, it.s);
        if (it.kind === "lotus") lotus(g, x + it.s * 0.15, y - it.s * 0.05, it.s * 0.7, it.ph > 4);
        if (it.kind === "lily") lily(g, x, y - it.s * 0.08, it.s * 0.6);
        it.sx = x;
        it.sy = y;
      });
    });
    for (let i = 0; i < 3; i++) {
      const y = H * (0.5 + i * 0.12);
      gr = g.createLinearGradient(0, y - 30, 0, y + 30);
      gr.addColorStop(0, "rgba(246,240,244,0)");
      gr.addColorStop(0.5, `rgba(246,240,244,${0.32 * (1 - st.calm * 0.8)})`);
      gr.addColorStop(1, "rgba(246,240,244,0)");
      g.fillStyle = gr;
      g.fillRect(0, y - 30, W, 60);
    }
    raf = requestAnimationFrame(frame);
  };
  raf = requestAnimationFrame(frame);
  const ripple = (cx, cy, k) => {
    if (st.stage !== "pond") return null;
    const r = canvas.getBoundingClientRect();
    const x = cx - r.left;
    const y = cy - r.top;
    if (y < H * 0.45) return null;
    rings.push({ x, y, t0: performance.now(), k });
    st.ripples++;
    layers.flat().forEach((it) => {
      const d = Math.hypot((it.sx || 0) - x, ((it.sy || 0) - y) * 2.5);
      if (d < 180) {
        it.bob = Math.min(1.5, it.bob + (1 - d / 180) * k);
        it.dx += Math.sign((it.sx || 0) - x) * (1 - d / 180) * 10 * k;
      }
    });
    return { x, y };
  };
  let drag = false;
  let lastRip = 0;
  window.__afaeLotus = { info: () => ({ stage: st.stage, ripples: st.ripples, calm: +st.calm.toFixed(2), mode: "2d" }) };
  return {
    down: (e) => {
      drag = true;
      return ripple(e.clientX, e.clientY, 1);
    },
    move: (e) => {
      st.px = (e.clientX / window.innerWidth - 0.5) * -1;
      if (!drag || performance.now() - lastRip < 140) return null;
      lastRip = performance.now();
      return ripple(e.clientX, e.clientY, 0.6);
    },
    up: () => (drag = false),
    setStage: (s) => (st.stage = s),
    destroy: () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", size);
    },
  };
}
